<template>
  <div>
    <pc-header ></pc-header>
    <h4 class="mt-5 ml-4">Password Recovery</h4>
    <div class="mt-2 ml-4 text-secondary">Type new password for your account:</div>
    <el-form ref="form" :rules="rules" :model="new_password_form" class="mt-4" label-width="150px" style="max-width: 500px">
      <el-form-item label="New Password" prop="password">
        <el-input type="password" autocomplete="new-password" v-model="new_password_form.password"></el-input>
      </el-form-item>
      <el-form-item label="Repeat Password" prop="password_repeat">
        <el-input type="password" autocomplete="new-password" v-model="new_password_form.password_repeat"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startPasswordReset" v-loading="loading">Reset Password</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import axios from 'axios'

  import PcHeader from '../components/pc-header.component'
  import {track} from '../ga-events'
  import config from '../config'

  export default {
    components: {PcHeader},
    computed: {
      token () {
        return this.$route.query.t
      },
    },
    data () {
      var validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password'));
        } else {
          if (this.new_password_form.password_repeat !== '') {
            this.$refs.form.validateField('password_repeat');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please input the password again'));
        } else if (value !== this.new_password_form.password) {
          callback(new Error('Two inputs don\'t match!'));
        } else {
          callback();
        }
      };
      return {
        loading: false,
        new_password_form: {
          password: '',
          password_repeat: '',
        },
        rules: {
          password: [
            { required: true, validator: validatePass, trigger: 'blur' },
            { min: 8, message: 'Your password is too short. Please use at least 8 symbols', trigger: 'blur' }
          ],
          password_repeat: [
            { required: true, validator: validatePass2, trigger: ['blur', 'change'] }
          ],
        },
      }
    },
    name: 'pc-new-password',
    methods: {
      async startPasswordReset () {
        let is_valid = false
        this.$refs.form.validate((valid) => {
          if (valid) {
            is_valid = true
          } else {
            console.log('error submit!!');
            return false;
          }
        });
        if (!is_valid) {
          return
        }
        track('my_profile', 'password_reset', this.token)
        this.loading = true
        try {
          let response = await axios.post(config.api_root + '/api/change-password', {token: this.token, password: this.new_password_form.password})
          this.$alert('Password has been changed. You will need to sign in again due to security considerations.', 'Password Recovery', {
            confirmButtonText: 'OK',
          });
        }catch (error) {
          let cause = ''
          if (error.response) {
            let server_cause = error.response.data.cause
            if (server_cause) {
              cause = '\n\n'+server_cause
            }
          }
          this.$alert('There was an error while trying to change password. Please try again or contact support. Details: ' + cause, 'Huston...', {
            confirmButtonText: 'OK',
          });
        }
        finally {
          this.loading = false
        }


        this.$router.push('/sign-in')
      },
    },
  }
</script>

<style scoped>

</style>